import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getTestResultFormConfig = ({
  internalAuditEnabled = false,
  oversightEnabled = false,
}: {
  internalAuditEnabled?: boolean;
  oversightEnabled?: boolean;
} = {}) => {
  return {
    AssessmentId: {
      fieldId: 'AssessmentId',
      formLabel: t('assessmentResults.fields.Assessment'),
    },
    ParentControlIds: {
      fieldId: 'ParentControlIds',
      formLabel: t(`control`),
      columnHeader: t(`testResults.columns.parent`),
    },
    TestType: {
      fieldId: 'TestType',
      formLabel: t(`testType`),
      columnHeader: t(`testResults.columns.test_type`),
      available: !internalAuditEnabled && !oversightEnabled,
    },
    Title: {
      fieldId: 'Title',
      formLabel: t(`titleField`),
      columnHeader: t(`testResults.columns.title`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
    },
    DesignEffectiveness: {
      fieldId: 'DesignEffectiveness',
      formLabel: t(`designEffectiveness`),
      columnHeader: t(`testResults.columns.design_effectiveness`),
      displayType: {
        displayType: 'rating',
        ratingKey: 'design_effectiveness',
      },
      allowTargetConditions: true,
      allowAsConditionSource: true,
    },
    PerformanceEffectiveness: {
      fieldId: 'PerformanceEffectiveness',
      formLabel: t(`performanceEffectiveness`),
      columnHeader: t(`testResults.columns.performance_effectiveness`),
      displayType: {
        displayType: 'rating',
        ratingKey: 'performance_effectiveness',
      },
      allowTargetConditions: true,
      allowAsConditionSource: true,
    },
    OverallEffectiveness: {
      fieldId: 'OverallEffectiveness',
      formLabel: t(`controlTestResult`),
      columnHeader: t(`testResults.columns.overall_effectiveness`),
      displayType: {
        displayType: 'rating',
        ratingKey: 'effectiveness',
      },
      allowTargetConditions: true,
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`controlTestDetails`),
      columnHeader: t(`columns.description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Submitter: {
      fieldId: 'Submitter',
      formLabel: t(`performedBy`),
      columnHeader: t(`testResults.columns.submitter`),
      displayType: { displayType: 'users', multiple: false },
      allowAsConditionSource: true,
    },
    TestDate: {
      fieldId: 'TestDate',
      formLabel: t(`testDate`),
      columnHeader: t(`testResults.columns.date`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
